import React from 'react';
import './Banner.css'

const Banner = () => {

    return (
        <>
            {/* <div className="container-fluid banner__main__wrapper">
                <div className="container">
                    <div className="row banner__text__wrapper">
                        <div className="col-12 banner__text" >
                            <p className='banner__top__header' //data-aos="fade-up"
                                data-aos-duration="3000"> INTRODUCING <span>FIRECHECKED</span></p>
                            <p className='banner__small__header' //data-aos="fade-up"
                                data-aos-duration="3000" data-aos-delay="500" >FireChecked offers fully accredited, third-party inspections for fire doors and fire-stopping compartmentation. Whether your requirements is for a single building or a full estate, our expert teams are on hand to deliver detailed surveys nationwide.</p>
                            <br />
                        </div>
                    </div>
                </div>
            </div> */}
        </>
    );
};

export default Banner;
